import service from '@/api/service/service';
import qs from "qs";

/* 单位设置 */
export function orgSet(data = {}) {
  return service({
    url: "/api/organization/organization_page.json",
    method: 'post',
    data: qs.stringify(data)
  });
}